import { checkStatus, json, FileAPI } from '@driftt/dapper'
import * as  RequestContentType from 'constants/RequestContentType'

export async function upload(file) {
  const data = new FormData()
  data.append('file', file)
  return FileAPI
    .post('/upload', data, {
      raw: true,
      headers: {},
    })
    .then(checkStatus)
    .then(json)
}



// WEBPACK FOOTER //
// ./src/scripts/app/api/FileAPI.js